import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@styles/color.styles";

const chipInput: CSSProperties = {
  width: "100%",
  flex: "none",
};

const sectionTitle: CSSProperties = {
  margin: "15px 0px 0px 15px",
  lineHeight: 1.5,
  fontSize: 14,
};

const suggestionsContainer: CSSProperties = {
  marginTop: 5,
  paddingTop: 5,
};

const suggestion: CSSProperties = {
  display: "block",
};

const suggestionsList: CSSProperties = {
  margin: 0,
  padding: 0,
  listStyleType: "none",
};

const searchIcon: CSSProperties = {
  color: greys.slate,
  width: 20,
  height: 20,
};

const searchField: CSSProperties = {
  backgroundColor: greys.palePaleGrey,
  padding: "0 10px",
  borderRadius: 4,
};

const searchInput: CSSProperties = {
  minHeight: 49,
  padding: 0,
};

export const styles = {
  chipInput,
  suggestionsContainer,
  searchField,
  searchIcon,
  searchInput,
  sectionTitle,
  suggestion,
  suggestionsList,
};
